import { render, staticRenderFns } from "./b-icon-select-checkbox.vue?vue&type=template&id=2cd4b40e&scoped=true"
import script from "./b-icon-select-checkbox.vue?vue&type=script&lang=js"
export * from "./b-icon-select-checkbox.vue?vue&type=script&lang=js"
import style0 from "./b-icon-select-checkbox.vue?vue&type=style&index=0&id=2cd4b40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4b40e",
  null
  
)

export default component.exports